module.exports = __webpack_public_path__ + "img/sign.da383513.png";